import { Pipe, PipeTransform } from '@angular/core';
import { Currency, getCurrencyLabel } from '../constants/currencies';

@Pipe({
  name: 'currencyCode',
})
export class CurrencyCodePipe implements PipeTransform {
  transform(
    value: Currency,
    format: 'full' | 'symbol' | 'code' = 'full'
  ): string {
    if (format === 'code') {
      return getCurrencyLabel(value).split(' ')[0];
    }
    return getCurrencyLabel(value, format === 'symbol' ? 'symbol' : undefined) || 'None';
  }
}
